export const StorageKey = {
    RecentSearches: 'silta/recentSearches',
}
